import React from 'react';
import { Button, Table } from 'antd';
import './CompaniesTable.scss';
import Input from 'antd/es/input/Input';
import { ReactSVG } from 'react-svg';
import moment from 'moment';
import './VehiclesTable.scss';
import { DAYTIME_FORMAT, VEHICLE_CAPACITY } from '../../constants';
import { getVehicleEmoji } from '../Forms/Vehicles/VehicleForm';

const VehiclesTable = ({
  withAction,
  dataSource,
  onSearch,
  onChangeSearch,
  isFetching,
  searchValue,
  selectedRowKeys,
  onSelectChange,
  ...props
}) => {
  const columns = [
    {
      title: '',
      dataIndex: 'vehicleCategory',
      fixed: 'left',
      width: 35,
      render: (text, record) => {
        return getVehicleEmoji(record.vehicleCategory);
      },
    },
    {
      title: 'Vehicle ID',
      dataIndex: 'vehicleId',
      key: 'vehicleId',
      fixed: 'left',
      width: 150,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Vehicle Type',
      dataIndex: 'vehicleType',
      key: 'vehicleType',
    },
    {
      title: 'Capacity',
      key: 'capacity',
      width: 120,
      render: (row) => {
        return VEHICLE_CAPACITY[row.vehicleType] || '';
      },
    },
    {
      title: 'Capabilities',
      dataIndex: 'capabilities',
      key: 'capabilities',
      render: (value, row) => {
        return value.map((capability, index) => (
          <div key={row.vehicleId + capability + index} className="capability-td">
            {capability}
          </div>
        ));
      },
    },

    {
      title: 'Start Address',
      dataIndex: 'startAddress',
      width: 500,
      key: 'startAddress',
    },
    {
      title: 'End Address',
      dataIndex: 'endAddress',
      width: 500,
      key: 'endAddress',
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value) => {
        return moment(value).format(DAYTIME_FORMAT);
      },
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (value) => {
        return moment(value).format(DAYTIME_FORMAT);
      },
    },
  ];

  if (withAction) {
    columns.push({
      key: 'action',
      width: 120,
      fixed: 'right',
      render(record) {
        return withAction(record);
      },
    });
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearch && onSearch();
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div className="table-vehicles table-common">
      <div className="vehicles-header table-header">
        <div className="search">
          <Input
            onChange={onChangeSearch}
            onBlur={onSearch}
            placeholder="Search"
            onKeyDown={handleKeyDown}
            suffix={<img src="/icons/search.svg" />}
            disabled={isFetching}
            value={searchValue}
          />
        </div>
        <div className="buttons">
          <Button className="FilterButton ButtonFilter">
            {selectedRowKeys?.length > 0 && <div className="count">{selectedRowKeys.length}</div>}
            Action <ReactSVG className="icon" src="/icons/arrow_drop_down.svg" />
          </Button>
          <Button className="FilterButton ButtonFilter">
            Filter
            <ReactSVG className="icon" src="/icons/filter_list.svg" />
          </Button>
        </div>
      </div>
      <Table
        columns={columns}
        rowSelection={rowSelection}
        scroll={{ x: 2600 }}
        dataSource={dataSource}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-dark' : 'table-row-light')}
        {...props}
      />
    </div>
  );
};

export default VehiclesTable;
